import toast, { Toast } from 'react-hot-toast'
import { Trash2 } from 'lucide-react'
import { Button } from '@/src/renderer/components/ui/Button'
import type { UndoToastOptions } from './UndoToast.types'
import './UndoToast.scss'

export function showUndoToast({
  message,
  undoLabel,
  onUndo,
  duration = 6000,
}: UndoToastOptions) {
  return toast.custom(
    (t: Toast) => (
      <div
        className={`undo-toast ${t.visible ? 'undo-toast--visible' : 'undo-toast--hidden'}`}
      >
        <Trash2 size={18} className="undo-toast__icon" />
        <span className="undo-toast__message">{message}</span>
        <Button
          variant="outline"
          size="small"
          onClick={async () => {
            toast.dismiss(t.id)
            await onUndo()
          }}
        >
          {undoLabel}
        </Button>
      </div>
    ),
    { duration }
  )
}
